module.exports = __webpack_public_path__ + "media/retinol-medium.626c3878.mp4";